(function () {
    'use strict';

    function signalrService($http) {
        function getConnectionInfo(url) {
            return $http.post(url).then(function (response) {
                return response.data;
            });
        }

        return {
            getConnectionInfo: getConnectionInfo
        }
    }

    signalrService.$inject = ['$http'];

    angular.module('ecap.common').service('signalrService', signalrService);
})();
